<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-right">
							<router-link v-if="antesDia25 && !yaSolicitadoEsteMes" class="btn GeneralLeave-back btnBack" to="/anticipos/nuevo">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nuevo Anticipo
							</router-link>
							<a v-else href="javascript:void(0);" class="btn GeneralLeave-back btnBack" @click="avisar">
							    <font-awesome-icon icon="fa-solid fa-circle-plus" /> Nuevo Anticipo
							</a>
						</div>
						<div class="title">
							<h3>Anticipos</h3>
						</div>
					</div>

					<div class="itemList-header">
						<h1>Solicitudes de anticipos</h1>
					</div>
					<div class="itemList-content row">
						<!---->
						<div v-if="anticipos.length == 0" class="AdvanceRequest-title col-md-12 NotFound text-center">
							No hay resultados
						</div>
						<section v-else id="no-more-tables" class="col-md-12 text-center">
							<table class="table" id="tblGeneralLeave">
								<thead>
									<tr>
										<th class="colDate">Fecha</th>
										<th class="colDate">Descripción</th>
										<th class="colType">Importe</th>
										<th class="colType">Estado</th>
										<th class="colAction">Acción</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="anticipo in anticipos">
										<td class="colDate" data-title="Fecha : ">
											{{ anticipo.fechaSolicitud }}
										</td>
										<td class="colDate" data-title="Descripción : ">
											{{ anticipo.titulo }}
										</td>
										<td class="colType" data-title="Importe : ">
											{{ anticipo.importe.replace('.',',') }}
										</td>
										<td class="colType" data-title="Estado : ">
											{{ anticipo.estado }}
										</td>
										<td class="colAction" data-title="Acción : ">
											<!-- <router-link :to="`/anticipos/editar/${anticipo.id}`">
												<font-awesome-icon icon="fa-solid fa-pencil" />
											</router-link> -->
											<a 
												v-if="anticipo.estado=='En Curso'" 
												href="javascript:void(0);" 
												class="btnDelete"
												@click="borrar(anticipo.id)"
											>
												<font-awesome-icon icon="fa-solid fa-times" />
											</a>
											<router-link :to="`/anticipos/ver/${anticipo.id}`">
												<font-awesome-icon icon="fa-solid fa-eye" />
											</router-link>
											&nbsp;&nbsp;
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</div>
					<div class="itemList-footer">
						<div class="pagination text-center AdvanceRequest-paging"></div>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Encabezado from "@/components/Encabezado.vue";
import Footer from "@/components/Footer.vue";

export default {
	name: "Anticipos",
	components: {
		Encabezado,
		Footer,
	},
	data() {return {
		texto: "Esta solicitud está fuera de plazo. Podrá realizar la solicitud desde el día 1 al 25 del mes que viene."
	}},
	mounted() {
		this.$store.commit('establecerGuardadoOK', false);

		document.body.classList.remove("bg-login");
		document.body.classList.remove("login-page");
	},
	watch:{
		guardadoOK: function(newValue){
			if (newValue){
				this.$toast.open({
					message: "La Solicitud de Anticipo se ha borrado correctamente",
					type: "success",
					duration: 1000,
					dismissible: false,
					position: "top",
					onDismiss: this.redireccionListaAnticipos
				});
			}
		}
	},
	computed: {
		anticipos: function(){
			const anticipos = this.$store.state.perfil.anticipos || [];
			
			return (Array.isArray(anticipos))?anticipos:[anticipos];
		},
		guardadoOK: function(){
			return this.$store.state.guardadoOK;
		},
		antesDia25: function(){
			const dia = this.moment().format('DD') * 1;

			return dia <= 25;
		},
		yaSolicitadoEsteMes: function(){
			const moment = this.moment;
			const mesFechaActual = moment().format('MM/YYYY');
			
			return this.anticipos.some(function(anticipo){
				const mesFechaSolicitud = moment(anticipo.fechaSolicitud, 'DD/MM/YYYY').format('MM/YYYY');
				const mismoMes = (mesFechaSolicitud === mesFechaActual);
				const estadoDistintoRechazado = (anticipo.estado !== 'Rechazado');

				return (mismoMes && estadoDistintoRechazado);
			});			
		}
	},
	methods:{
		borrar: function(id){
			if (confirm('Atención: Borrar Solicitud de Anticipo'))
				this.$store.dispatch('borrarAnticipo', {'id': id});
		},
		redireccionListaAnticipos: function(){
			//router.replace('/anticipos');
			this.$store.commit('establecerGuardadoOK', false);
		},
		avisoDespuesDia25: function(){
			alert("Atención: No es posible solicitar anticipos después del 25 de cada mes");
		},
		avisoYaSolicitadoEsteMes: function(){
			alert("Atención: Sólo es posible solicitar un anticipo al mes");
		},
		avisar: function(){
			if (!this.antesDia25) return this.avisoDespuesDia25();
			if (this.yaSolicitadoEsteMes) return this.avisoYaSolicitadoEsteMes();
		}
	}
};
</script>

<style>
	@import "../assets/styles/home.css";
</style>
